import {Component} from '@angular/core';

@Component({
  selector: 'app-step-five-left-panel',
  templateUrl: './step-five-left-panel.component.html',
  styleUrls: ['./step-five-left-panel.component.css']
})
export class StepFiveLeftPanelComponent {

}
